export * from './locale.service';
export * from './translate-resolver.service';
export * from './languages-resolver.service';

